// assets
import {
  IconHome,
  IconShoppingBag,
  IconCalendar,
  IconWindmill,
  IconHotelService,
  IconWallet,
} from "@tabler/icons";

// constant
const icons = {
  IconWallet,
  IconHome,
  IconShoppingBag,
  IconCalendar,
  IconWindmill,
  IconHotelService,
};

// ==============================|| EXTRA PAGES MENU ITEMS ||============================== //

const pages = {
  id: "pages",
  title: "Products",
  type: "group",
  children: [
    {
      id: "authentication",
      title: "Experiences",
      type: "collapse",
      icon: icons.IconWindmill,
      children: [
        {
          id: "expList",
          title: "Experiences List",
          type: "item",
          url: "/experiences",
        },
        {
          id: "experience-bookings",
          title: "Bookings",
          type: "item",
          url: "/experience-bookings",
        },
      ],
    },
    {
      id: "homes",
      title: "Homes",
      type: "collapse",
      icon: icons.IconHome,

      children: [
        {
          id: "homes-list",
          title: "Homes List",
          type: "item",
          url: "/homes",
        },
        // {
        //   id: "reservation",
        //   title: "Reservations",
        //   type: "item",
        //   url: "/reservations",
        // },
        {
          id: "booking",
          title: "Bookings",
          type: "item",
          url: "/home-bookings",
        },
      ],
    },
    {
      id: "hotels",
      title: "Hotels",
      type: "collapse",
      icon: icons.IconHotelService,

      children: [
        {
          id: "hotels-list",
          title: "Hotels List",
          type: "item",
          url: "/hotels",
        },
        {
          id: "booking",
          title: "Bookings",
          type: "item",
          url: "/hotel-bookings",
        },
      ],
    },
    {
      id: "shop",
      title: "Stores",
      type: "collapse",
      icon: icons.IconShoppingBag,

      children: [
        {
          id: "stores-list",
          title: "Stores",
          type: "item",
          url: "/stores",
        },
        {
          id: "shop-orders",
          title: "Orders & payouts",
          type: "item",
          url: "/shop-orders",
        },
        {
          id: "products-list",
          title: "Products",
          type: "item",
          url: "/products",
        },
        {
          id: "shop-domains",
          title: "Domains",
          type: "item",
          url: "/shop-domains",
        },
        {
          id: "shop-integrations",
          title: "Integrations",
          type: "item",
          url: "/shop-integrations",
        },
        {
          id: "categories-list",
          title: "Categories",
          type: "item",
          url: "/categories",
        },
      ],
    },
    {
      id: "wallet",
      title: "Wallets",
      type: "collapse",
      icon: icons.IconWallet,

      children: [
        {
          id: "wallet-list",
          title: "Wallets",
          type: "item",
          url: "/wallets",
        },
      ],
    },
    {
      id: "event",
      title: "Events",
      type: "collapse",
      icon: icons.IconCalendar,

      children: [
        {
          id: "events-list",
          title: "Events",
          type: "item",
          url: "/events",
        },
        {
          id: "event-bookings",
          title: "Bookings",
          type: "item",
          url: "/event-bookings",
        },
      ],
    },
  ],
};

export default pages;
